import { Divider, Stack, useTheme } from '@mui/material'
import { isEmpty } from 'lodash'

import Typography from 'ComponentLibrary/src/atoms/typography/Typography'
import { MessageFile } from 'ComponentLibrary/src/molecules/Message/types'
import { Attachment } from 'ComponentLibrary/src/molecules/Attachement/Attachement'
import { tokens } from 'ComponentLibrary'

type AttachmentPreviewProps = {
    label?: string
    documents: MessageFile[]
} & (DownloadOnlyProp | RemoveOnlyProp)

type DownloadOnlyProp = {
    downloadDocument: (index: number) => void
}

type RemoveOnlyProp = {
    removeDocument: (index: number) => void
}

export const AttachmentPreview = ({ label, documents, ...props }: AttachmentPreviewProps) => {
    const theme = useTheme()

    if (isEmpty(documents)) {
        return null
    }

    return (
        <Stack direction="column" gap={theme.spacing(2)}>
            {label && (
                <Divider textAlign="left" sx={{ marginTop: '4px' }}>
                    <Typography variant="bodyTextSmall" color={theme.palette.customtext.black38}>
                        {label}
                    </Typography>
                </Divider>
            )}
            <Stack direction="column">
                {!isEmpty(documents) && (
                    <Stack direction="column" gap={tokens.SizingSpacing200}>
                        {documents.map((document, index) => {
                            const commonProps = {
                                file: document,
                                index,
                            }
                            if ('downloadDocument' in props) {
                                return <Attachment key={index} {...commonProps} onDownload={() => props.downloadDocument(index)} />
                            }
                            return <Attachment key={index} {...commonProps} onRemove={() => props.removeDocument(index)} />
                        })}
                    </Stack>
                )}
            </Stack>
        </Stack>
    )
}
